import React, { useContext } from "react";
import { ContactFields } from "./Fields";
import MultiForm from "./MultipleForm";

const ContactsForms = () => {
  const addNewItem = React.useCallback((key) => {
    const fields = ContactFields(key);

    return { id: key, fields };
  }, []);

  return <MultiForm heading="contact" addNewItem={addNewItem} />;
};

export default ContactsForms;
